<script setup lang="ts">
import { DefaultPage } from "@vm/vue-core";

import ComparisonSettingsForm from "../comparison-settings-form.vue";

import { useSettingsEditorStore } from "@/editor/use-settings-editor-store";

const settingsEditorStore = useSettingsEditorStore();
const { closeDialog } = settingsEditorStore;

async function handleSubmit() {
  closeDialog();
}
</script>

<template>
  <DefaultPage class="p-6">
    <ComparisonSettingsForm @submit="handleSubmit" />
  </DefaultPage>
</template>
